var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.landingMasthead'] = (function () {
    'use strict';

    const initialize = (widget) => {
        App.ZagParallax.initialize('.landing-masthead', '.landing-masthead__bg', { divisor: 1.25 });
    };

    return {
        initialize
    };

})();